module.exports = __webpack_public_path__ + "img/core.2b733be3.jpg";